import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, mergeProps as _mergeProps, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "upload-input" }
const _hoisted_2 = { class: "upload-input__head" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "upload-input__title" }
const _hoisted_5 = { class: "upload-input__data-type data-type" }
const _hoisted_6 = { class: "data-type__top" }
const _hoisted_7 = { class: "data-type__title" }
const _hoisted_8 = { class: "data-type__text" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "data-type__top" }
const _hoisted_11 = { class: "data-type__title" }
const _hoisted_12 = { class: "data-type__text" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "upload-input__select-header select-header" }
const _hoisted_15 = { class: "select-header__text" }
const _hoisted_16 = { class: "select-header__text--note" }
const _hoisted_17 = { class: "select-header__header-input header-input" }
const _hoisted_18 = { class: "header-input__label" }
const _hoisted_19 = { class: "header-input__input-text" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "header-input__input-text--unit" }
const _hoisted_22 = {
  key: 0,
  class: "header-input__input-text--error"
}
const _hoisted_23 = {
  key: 1,
  class: "header-input__input-text--error"
}
const _hoisted_24 = {
  key: 2,
  class: "header-input__input-text--error"
}
const _hoisted_25 = { class: "upload-input__upload-container" }
const _hoisted_26 = {
  key: 0,
  "data-testid": `input_file_content`,
  class: "dz-file-preview dz-preview"
}
const _hoisted_27 = { class: "dz-details" }
const _hoisted_28 = { class: "file-name-and-size" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "dz-default" }
const _hoisted_31 = { class: "upload-input__button-container" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import HelpIconWithModal from '@/corePagesModule/components/HelpIconWithModal.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import { ReadFileService } from '@/registerInputModule/service/ReadFileService';
import { computed, ref, watch } from 'vue';
import { assertNever } from '@/coreDomainsModule/assertNever';


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadInput',
  props: {
    store: {}
  },
  emits: ["on-click-next", "on-click-back"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const { state } = storeToRefs(props.store);

const emits = __emit;

const localeSuffix = ref(i18n.locale === 'en' ? '__en' : '');

watch(
  () => i18n.locale,
  (newVal) => {
    localeSuffix.value = newVal === 'en' ? '__en' : '';
  },
  {
    immediate: true,
  }
);

const imagesRequire = require.context('@/assets/img', false, /^\.\/register-input.*\.png$/);

const localedImage = computed(() => {
  const registerInputDataImageSrc = './register-input-data-';
  const flowImageSrc = './register-input-step-flow-1' + localeSuffix.value + '.png';
  return {
    flowImage: imagesRequire(flowImageSrc),
    registerInputData: [...Array(2)].map((_, index) =>
      imagesRequire(registerInputDataImageSrc + (index + 1) + localeSuffix.value + '.png')
    ),
  };
});

/**
 * 戻るボタン
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

/**
 * 次へボタン
 */
const onClickNextButton = () => {
  emits('on-click-next');
};

const title = computed(() => {
  switch (state.value.uploadInput.inputFileType) {
    case '在庫':
      return t('入力アップロード：タイトル（在庫）');
    case '販売実績':
      return t('入力アップロード：タイトル（販売実績）');
    case '入荷':
      return t('入力アップロード：タイトル（入荷）');
    case '発注':
      return t('入力アップロード：タイトル（発注）');
    default:
      assertNever(state.value.uploadInput.inputFileType);
      return '';
  }
});

const type1Style = computed((): string => {
  return state.value.uploadInput.useFormatType === 'Inlined' ? 'data-type--selected' : 'data-type--not-selected';
});

const type2Style = computed((): string => {
  return state.value.uploadInput.useFormatType === 'InHeader' ? 'data-type--selected' : 'data-type--not-selected';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(title.value), 1),
    _createElementVNode("img", {
      src: localedImage.value.flowImage,
      class: "upload-input__progress"
    }, null, 8, _hoisted_3),
    (_unref(state).uploadInput.inputFileType !== '発注')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('入力アップロード：データ形式選択')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", {
              for: "data-type-1",
              class: _normalizeClass(["data-type__type-1", type1Style.value])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('入力アップロード：データ形式1：タイトル')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "data-type-1",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).uploadInput.useFormatType) = $event)),
                  class: "data-type__radio-button",
                  type: "radio",
                  value: 'Inlined'
                }, null, 512), [
                  [_vModelRadio, _unref(state).uploadInput.useFormatType]
                ])
              ]),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('入力アップロード：データ形式1：タイトル：補足')), 1),
              _createElementVNode("img", {
                src: localedImage.value.registerInputData[0],
                class: "data-type__image"
              }, null, 8, _hoisted_9)
            ], 2),
            _createElementVNode("label", {
              for: "data-type-2",
              class: _normalizeClass(["data-type__type-2", type2Style.value])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('入力アップロード：データ形式2：タイトル')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "data-type-2",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).uploadInput.useFormatType) = $event)),
                  class: "data-type__radio-button",
                  type: "radio",
                  value: 'InHeader'
                }, null, 512), [
                  [_vModelRadio, _unref(state).uploadInput.useFormatType]
                ])
              ]),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('入力アップロード：データ形式2：タイトル：補足')), 1),
              _createElementVNode("img", {
                src: localedImage.value.registerInputData[1],
                class: "data-type__image"
              }, null, 8, _hoisted_13)
            ], 2)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('入力アップロード：ヘッダー行指定')), 1),
        _createVNode(HelpIconWithModal, {
          "use-transform": true,
          class: "select-header__text--help-icon"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('')), 1)
          ], undefined, true),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('行番号')), 1),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).uploadInput.headerNumber.value) = $event)),
            class: "header-input__input-text--form",
            type: "number",
            placeholder: _unref(t)('半角数字')
          }, null, 8, _hoisted_20), [
            [_vModelText, _unref(state).uploadInput.headerNumber.value]
          ]),
          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('行')), 1)
        ]),
        (_unref(state).uploadInput.headerNumber.validateError == 'AtLeastOne')
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(t)('取引設定：数値バリデーション：1以上エラー')), 1))
          : (_unref(state).uploadInput.headerNumber.validateError == 'Empty')
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(t)('取引設定：数値バリデーション：空文字エラー')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString('　')))
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _mergeProps(_ctx.store.getRootProps(), { class: "mb-20px dropzone" }), [
        _createElementVNode("input", _mergeProps(_ctx.store.getInputProps(), { "data-testid": `dropzone_input_area` }), null, 16),
        (_unref(state).uploadInput.inputFile != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(state).uploadInput.inputFile], (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "dz-file-content"
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", null, _toDisplayString(_unref(ReadFileService).fetchNameForEvent(file)), 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(ReadFileService).getFileSizeStr(file)), 1)
                    ]),
                    _createElementVNode("span", {
                      class: "dz-remove",
                      onClick: _withModifiers(($event: any) => (_ctx.store.handleClickDeleteFile(index)), ["stop"])
                    }, " Delete ", 8, _hoisted_29)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", {
            class: _normalizeClass(["dz-message", _ctx.store.isDragActive])
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("i", null, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_unref(t)('ここにファイルをドロップ')), 1)
          ], 2)
        ])
      ], 16)
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(TextButton, {
        "button-style": 'btn-secondary',
        size: 'btn-md',
        "on-click": onClickBackButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：戻るボタン')), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(TextButton, {
        "button-style": 'btn-primary',
        size: 'btn-md',
        "on-click": onClickNextButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：次へボタン')), 1)
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})